import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoItsForSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const forList = ['Introverts who want income without the spotlight', '9-5 employees looking for a side income stream', 'Digital entrepreneurs ready to build assets', 'Beginners with zero YouTube experience', 'Anyone who values systems over hustle'];
  const notForList = ['Get-rich-quick seekers expecting overnight results', 'Influencers who want to build a personal brand', "People who can't follow a structured system", 'Those unwilling to put in 60 minutes per video', 'Anyone looking for a "done for you" service'];
  return <section ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-primary" data-id="element-291">
      <div className="max-w-6xl mx-auto" data-id="element-292">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-293">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-294">
            Is This <span className="text-accent-green" data-id="element-295">Right For You?</span>
          </h2>
          <p className="text-text-muted text-lg" data-id="element-296">
            This system works incredibly well for the right person. Let's make
            sure that's you.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-297">
          {/* Who It's For */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="glass-card rounded-2xl p-8 border-accent-green/20" data-id="element-298">
            <div className="flex items-center gap-3 mb-6" data-id="element-299">
              <div className="w-10 h-10 rounded-full bg-accent-green/20 flex items-center justify-center" data-id="element-300">
                <CheckCircleIcon className="w-5 h-5 text-accent-green" data-id="element-301" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-302">
                This Is For You If...
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-303">
              {forList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-304">
                  <CheckCircleIcon className="w-5 h-5 text-accent-green flex-shrink-0 mt-0.5" data-id="element-305" />
                  <span className="text-text-light" data-id="element-306">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who It's Not For */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="glass-card rounded-2xl p-8 border-red-500/20" data-id="element-307">
            <div className="flex items-center gap-3 mb-6" data-id="element-308">
              <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-309">
                <XCircleIcon className="w-5 h-5 text-red-500" data-id="element-310" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-311">
                This Is NOT For You If...
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-312">
              {notForList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-313">
                  <XCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-314" />
                  <span className="text-text-light" data-id="element-315">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}